<template>
  <panel-navigation>
    <div class="agency-start-shell" v-if="me">
      <header class="agency-start-hero">
        <div>
          <p class="eyebrow">White label account created</p>
          <h1>Welcome to LSA Command</h1>
          <p class="hero-copy">Your white label agency account is ready. Set up your first client to start connecting leads, calls, and reports under your brand.</p>
        </div>
        <div class="hero-mark"><i class="mdi mdi-check-circle-outline"></i></div>
      </header>

      <main class="agency-start-panel">
        <div class="step-heading">
          <span>Next step</span>
          <h2>Set up your first client</h2>
          <p>Add the business you want to manage, then we will take you directly into its setup checklist.</p>
        </div>

        <div class="info-box">
          <i class="mdi mdi-briefcase-plus-outline"></i>
          <div>
            <strong>Start with your client's business information</strong>
            <p>Search for the business online to fill in its details quickly, or enter them manually. You can add more clients later from Businesses.</p>
          </div>
        </div>

        <button class="primary" @click="$refs.dialogAddBusiness.show()">
          <i class="mdi mdi-plus"></i>
          Add your first client
        </button>
        <button class="secondary-btn" @click="$router.push('/businesses')">
          Go to Businesses
        </button>
      </main>

      <dialog-add-business
        ref="dialogAddBusiness"
        :is_business="true"
        :redirect_to_onboarding="true"
      ></dialog-add-business>
    </div>
  </panel-navigation>
</template>

<script>
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'
import DialogAddBusiness from '@/components/dialogs/businesses/addBusiness.vue'

export default {
  components: {
    PanelNavigation,
    DialogAddBusiness
  },
  computed: {
    ...mapState({
      me: state => state.me.me
    })
  },
  metaInfo () {
    return {
      title: 'Get Started | ' + this.$appName
    }
  }
}
</script>

<style scoped>
.agency-start-shell { max-width: 1180px; margin: 0 auto; color: #24313d; }
.agency-start-hero { background: linear-gradient(120deg, #173f4f, #2d756b); color: white; padding: 42px 34px; border-radius: 10px; display: flex; justify-content: space-between; gap: 30px; align-items: center; }
.eyebrow { text-transform: uppercase; letter-spacing: 2px; font-size: 11px; opacity: .75; margin: 0 0 8px; }
h1 { font-size: 30px; margin: 0 0 8px; }
.hero-copy { max-width: 650px; margin: 0; opacity: .88; line-height: 1.55; }
.hero-mark { font-size: 72px; color: #f4c95d; line-height: 1; }
.agency-start-panel { background: white; border: 1px solid #e1e8ea; border-radius: 8px; padding: 30px; margin-top: 24px; min-height: 300px; }
.step-heading { border-bottom: 1px solid #edf0f1; padding-bottom: 20px; margin-bottom: 24px; }
.step-heading span { color: #2d756b; font-size: 11px; font-weight: bold; text-transform: uppercase; }
.step-heading h2 { margin: 5px 0; font-size: 24px; }
.step-heading p { margin: 0; color: #71808a; }
.info-box { display: flex; gap: 13px; padding: 15px; background: #eef8f5; border-left: 4px solid #2d756b; margin-bottom: 24px; }
.info-box > i { font-size: 22px; color: #2d756b; }
.info-box strong { font-size: 13px; }
.info-box p { margin: 5px 0 0; font-size: 12px; line-height: 1.55; }
.primary, .secondary-btn { border-radius: 5px; padding: 10px 15px; cursor: pointer; font-size: 12px; font-weight: bold; }
.primary { background: #2d756b; color: white; border: 1px solid #2d756b; }
.secondary-btn { background: white; color: #2d756b; border: 1px solid #9ebbb5; margin-left: 8px; }
.primary i { margin-right: 5px; }
@media (max-width: 800px) { .agency-start-hero { padding: 26px 24px; display: block; }.hero-mark { font-size: 48px; margin-top: 22px; }.agency-start-panel { padding: 20px; } .secondary-btn { margin-left: 0; margin-top: 10px; } }
</style>
